<template>
  <SupplyForm
    class="mt-5 mb-5"
    pageTitle="Crear fitosanitario"
    supplyType="phytosanitary"
    submitButtonText="CREAR FITOSANITARIO"
    @dataFormValid="createPhytosanitarySupply"
  />
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage } from "naive-ui";
import supplyStore from "../../../store/supply";
import authStore from "../../../store/auth";
import SupplyForm from "../../../components/SuppliesComponents/supplyForm.vue";

export default {
  data() {
    return {
      message: useMessage(),
    };
  },
  mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
  },
  computed: {
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(supplyStore, ["createSupply"]),
    async createPhytosanitarySupply(newSupply) {
      try {
        await this.createSupply(newSupply);
        this.message.success("Suministro creado");
        this.$router.push("/app/supplies/phytosanitary/list");
      } catch (err) {
        console.error(err);
      }
    },
  },
  components: { SupplyForm },
};
</script>
